var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.352 13.5c0-.552.464-1 1.037-1h6.224c.573 0 1.037.448 1.037 1s-.464 1-1.037 1H5.389c-.573 0-1.037-.448-1.037-1m5.188-12c0-.552-.465-1-1.038-1s-1.038.448-1.038 1v5H5.39a.52.52 0 0 0-.48.309.49.49 0 0 0 .113.545l3.112 3a.53.53 0 0 0 .734 0l3.112-3a.49.49 0 0 0 .112-.545.52.52 0 0 0-.48-.309H9.54z",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;